import React from "react";
import tmdbLogo from "../assets/tmdb.svg";

export default function About() {
    return (
    <div className="max-w-7xl mx-auto px-6 py-12 text-white">
      {/* ELO Rating Section */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-4 text-purple-200">How It Works: ELO Rating</h2>
        <p className="text-gray-300 leading-relaxed">
          This app uses the ELO rating system to rank your movies. Originally developed for chess, 
          ELO works by having you compare two movies head-to-head. When you pick a winner, both movies' 
          ratings adjust based on the matchup. An upset victory (lower-rated beating higher-rated) causes 
          bigger rating swings than expected outcomes. Over time, your movies naturally sort themselves 
          into a personalized ranking that reflects your true preferences.
        </p>
      </section>

      {/* TMDB Disclosure Section */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-4 text-purple-200">Data Source</h2>
        <p className="text-gray-300 leading-relaxed mb-4">
          This product uses the TMDB API but is not endorsed or certified by TMDB.
        </p>
        <a 
          href="https://www.themoviedb.org/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-block hover:opacity-80 transition-opacity"
        >
          <img 
            src={tmdbLogo} 
            alt="TMDB Logo" 
            className="h-12"
          />
        </a>
      </section>

      {/* About Me Section */}
      <section>
        <h2 className="text-2xl font-bold mb-4 text-purple-200">About the Creator</h2>
        <p className="text-gray-300 leading-relaxed">
          Hi, I'm Christophe, a Software Engineer who built this site to solve a problem I've had for years: 
          figuring out what my actual favorite movie is. Traditional ranked lists felt arbitrary, 
          but head-to-head comparisons felt natural. So I created the ultimate way to finally answer 
          the question: What's my favorite movie?
        </p>
      </section>
    </div>
  );
}